const EMAIL_VERIFICATION_CONFIRMATION_WAITING_IS_TRUE = 'EMAIL_VERIFICATION_CONFIRMATION_WAITING_IS_TRUE';
const EMAIL_VERIFICATION_CONFIRMATION_WAITING_IS_FALSE = 'EMAIL_VERIFICATION_CONFIRMATION_WAITING_IS_FALSE';
const COUNTDOWN_FOR_LETTER_REQUEST = 'COUNTDOWN_FOR_LETTER_REQUEST';
const LAST_AUTHORIZATION = 'LAST_AUTHORIZATION';
const VALUE_IN_CHATSLIST_INPUT = 'VALUE_IN_CHATSLIST_INPUT';
const AQUARIUM_STATUS = 'AQUARIUM_STATUS';
const APP_THEME = 'APP_THEME';
const ONLY_SELECTED_CHATS = 'ONLY_SELECTED_CHATS';
const CHATS_COUNT = 'CHATS_COUNT';
const EVENT_FOR_PWA_INSTALLATION = 'EVENT_FOR_PWA_INSTALLATION';
const DEVICE_ON_THE_NETWORK_ACTION = 'DEVICE_ON_THE_NETWORK_ACTION';
const IS_STRICT_SEARCH_ACTION = 'IS_STRICT_SEARCH_ACTION';

export const emailVerificationConfirmationWaitingIsTrue = {
    type: EMAIL_VERIFICATION_CONFIRMATION_WAITING_IS_TRUE,
};

export const emailVerificationConfirmationWaitingIsFalse = {
    type: EMAIL_VERIFICATION_CONFIRMATION_WAITING_IS_FALSE,
};

export const countdownForLetterRequest = {
    type: COUNTDOWN_FOR_LETTER_REQUEST,
};

export const lastAuthorization = {
    type: LAST_AUTHORIZATION,
};

export const valueInChatsListInput = {
    type: VALUE_IN_CHATSLIST_INPUT,
};

export const aquariumStatus = {
    type: AQUARIUM_STATUS,
};

export const appTheme = {
    type: APP_THEME,
};

export const onlySelectedChats = {
    type: ONLY_SELECTED_CHATS,
};

export const chatsCount = {
    type: CHATS_COUNT,
};

export const eventForPWAInstallation = {
    type: EVENT_FOR_PWA_INSTALLATION,
};

export const deviceOnTheNetworkAction = {
    type: DEVICE_ON_THE_NETWORK_ACTION,
};

export const isStrictSearchAction = {
    type: IS_STRICT_SEARCH_ACTION,
};
